module.exports = __webpack_public_path__ + "assets/Kahu-tagline.ec057277.svg";